import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { useIdentity } from '../../../Authentication/Authentication.hooks';
import { DONATION_COUNT } from './DonationCounter.gql';
import { vercel_base_url } from '../../../../util/config';
import { BUILD } from '../../../../util/const';

import * as Styled from './DonationCounter.styled';

/**
 * The Donation Counter displays a customers donation count
 * based on purchase history
 */
const DonationCounter = ({ count, className }) => {
  const base_url = BUILD === 'shopify' ? vercel_base_url : '';

  return (
    <Styled.DonationCounter
      className={className}
      withDivider={false}
      header={
        <Styled.Title>
          {count !== '0' ? (
            <>
              Your Purchases Created{' '}
              <Styled.Emphasis>
                {count} Donation{count !== '1' ? 's' : ''}
              </Styled.Emphasis>{' '}
              for Those in Need
            </>
          ) : (
            <>One Purchased = One Donated</>
          )}
        </Styled.Title>
      }
    >
      <Styled.Body>
        {count !== '0' ? (
          <Styled.Desc>
            You&apos;re making a real impact.{' '}
            <Styled.Link
              as={BUILD === 'shopify' ? 'a' : undefined}
              href={`${base_url}/pages/giving-back`}
            >
              See how.
            </Styled.Link>
            {/* <Styled.QuestionTip onClick={(e) => setTooltipElement(e.target)} />
            <Styled.Tooltip
              anchorElement={tooltipElement}
              onClose={() => setTooltipElement(null)}
            >
              <Styled.TooltipBody>
                Want to know how our donation counter works?{' '}
                <Styled.Link href="">Visit FAQ Article.</Styled.Link>
              </Styled.TooltipBody>
            </Styled.Tooltip> */}
          </Styled.Desc>
        ) : (
          <>
            After purchasing, check here to see how many items you helped
            donate.{' '}
            <Styled.Link
              as={BUILD === 'shopify' ? 'a' : undefined}
              href={`${base_url}/pages/giving-back`}
            >
              How donations work.
            </Styled.Link>
          </>
        )}
      </Styled.Body>
    </Styled.DonationCounter>
  );
};

const DonationCounterWithData = ({ className }) => {
  const { user } = useIdentity();

  const { data } = useQuery(DONATION_COUNT, {
    variables: { email: user.email },
    skip: !user.email
  });

  const count = data?.user?.donationCount;

  if (count) {
    return <DonationCounter count={count} className={className} />;
  }

  return (
    <Styled.DonationCounter
      className={className}
      withDivider={false}
      header={<Styled.LoadingBlock $height={50} />}
    >
      <Styled.LoadingBlock />
    </Styled.DonationCounter>
  );
};

DonationCounter.propTypes = {
  /**
   * The amount of items donated for a customer
   */
  count: PropTypes.string.isRequired,
  className: PropTypes.string
};

DonationCounter.defaultProps = { className: undefined };

DonationCounterWithData.propTypes = {
  className: PropTypes.string
};

DonationCounterWithData.defaultProps = {
  className: undefined
};

export { DonationCounter };
export default DonationCounterWithData;
